<!-- START Sidebar (left)-->
<div class="aside-inner">
  <nav
    class="sidebar"
    sidebar-anyclick-close=""
    [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')"
    >
    <!-- START sidebar nav-->
    <ul class="sidebar-nav">
      <!-- START user info-->
      <li class="has-user-block mb-4">
        <app-userblock></app-userblock>
      </li>
      <!-- END user info-->

      @for (item of menuItems; track item) {
        <li
          [ngClass]="{ 'nav-heading': item.heading }"
          [routerLinkActive]="['active']"
          >
          <!-- menu heading -->
          @if (item.heading) {
            <span>{{ item.text }}</span>
          }
          <!-- external links -->
          @if (!item.heading && !item.submenu && item.elink) {
            <a
              [attr.target]="item.target"
              [attr.href]="item.elink"
              title="{{ item.text }}"
              >
              @if (item.alert) {
                <span
                  class="float-right"
                  [ngClass]="item.label || 'badge badge-success'"
                  >{{ item.alert }}</span
                  >
                }
                @if (item.icon) {
                  <em class="{{ item.icon }}"></em>
                }
                <span>{{ item.text }}</span>
              </a>
            }
            <!-- single menu item -->
            @if (!item.heading && !item.submenu && !item.elink) {
              <a
                [routerLink]="item.link"
                [attr.route]="item.link"
                title="{{ item.text }}"
                (click)="toggleSubmenuClick($event)"
                (mouseenter)="toggleSubmenuHover($event)"
                >
                @if (item.alert) {
                  <span
                    class="float-right"
                    [ngClass]="item.label || 'badge badge-success'"
                    >{{ item.alert }}</span
                    >
                  }
                  @if (item.icon) {
                    <em class="{{ item.icon }}"></em>
                  }
                  <span>{{ item.text }}</span>
                </a>
              }
              <!-- has submenu -->
              @if (!item.heading && item.submenu) {
                <button
                  type="button"
                  class="nav-link"
                  title="{{ item.text }}"
                  aria-label="{{ item.text }}"
                  (click)="toggleSubmenuClick($event)"
                  (mouseenter)="toggleSubmenuHover($event)"
                  >
                  @if (item.alert) {
                    <span
                      class="float-right"
                      [ngClass]="item.label || 'badge badge-success'"
                      >{{ item.alert }}</span
                      >
                    }
                    @if (item.icon) {
                      <em class="{{ item.icon }}"></em>
                    }
                    <span>{{ item.text }}</span>
                  </button>
                }
                <!-- SUBLEVEL -->
                @if (item.submenu) {
                  <ul
                    class="sidebar-nav sidebar-subnav"
                    [routerLinkActive]="['opening']"
                    >
                    <li class="sidebar-subnav-header">{{ item.text }}</li>
                    @for (subitem of item.submenu; track subitem) {
                      <li
                        [routerLinkActive]="['active']"
                        >
                        <!-- sublevel: external links -->
                        @if (!subitem.heading && !subitem.submenu && subitem.elink) {
                          <a
                            [attr.target]="subitem.target"
                            [attr.href]="subitem.elink"
                            title="{{ subitem.text }}"
                            >
                            @if (subitem.alert) {
                              <span
                                class="float-right"
                                [ngClass]="subitem.label || 'badge badge-success'"
                                >{{ subitem.alert }}</span
                                >
                              }
                              @if (subitem.icon) {
                                <em class="{{ subitem.icon }}"></em>
                              }
                              <span>{{ subitem.text }}</span>
                            </a>
                          }
                          <!-- sublevel: single menu item  -->
                          @if (!subitem.submenu && !subitem.elink) {
                            <a
                              [routerLink]="subitem.link"
                              [attr.route]="subitem.link"
                              title="{{ subitem.text }}"
                              >
                              @if (subitem.alert) {
                                <span
                                  class="float-right"
                                  [ngClass]="subitem.label || 'badge badge-success'"
                                  >{{ subitem.alert }}</span
                                  >
                                }
                                @if (subitem.icon) {
                                  <em class="{{ subitem.icon }}"></em>
                                }
                                <span>{{ subitem.text }}</span>
                              </a>
                            }
                            <!-- sublevel: has submenu -->
                            @if (subitem.submenu) {
                              <button
                                type="button"
                                class="nav-link"
                                title="{{ subitem.text }}"
                                aria-label="{{ subitem.text }}"
                                (click)="toggleSubmenuClick($event)"
                                (mouseenter)="toggleSubmenuHover($event)"
                                >
                                @if (subitem.alert) {
                                  <span
                                    class="float-right"
                                    [ngClass]="subitem.label || 'badge badge-success'"
                                    >{{ subitem.alert }}</span
                                    >
                                  }
                                  @if (subitem.icon) {
                                    <em class="{{ subitem.icon }}"></em>
                                  }
                                  <span>{{ subitem.text }}</span>
                                </button>
                              }
                              <!-- SUBLEVEL 2 -->
                              @if (subitem.submenu) {
                                <ul
                                  class="sidebar-nav sidebar-subnav level2"
                                  [routerLinkActive]="['opening']"
                                  >
                                  @for (subitem2 of subitem.submenu; track subitem2) {
                                    <li
                                      [routerLinkActive]="['active']"
                                      >
                                      <!-- sublevel 2: single menu item  -->
                                      @if (!subitem2.submenu) {
                                        <a
                                          [routerLink]="subitem2.link"
                                          [attr.route]="subitem2.link"
                                          title="{{ subitem2.text }}"
                                          >
                                          @if (subitem2.alert) {
                                            <span
                                              class="float-right"
                                              [ngClass]="subitem2.label || 'badge badge-success'"
                                              >{{ subitem2.alert }}</span
                                              >
                                            }
                                            @if (subitem2.icon) {
                                              <em class="{{ subitem2.icon }}"></em>
                                            }
                                            <span>{{ subitem2.text }}</span>
                                          </a>
                                        }
                                        <!-- sublevel2: has submenu -->
                                        @if (subitem2.submenu) {
                                          <button
                                            type="button"
                                            class="nav-link"
                                            title="{{ subitem2.text }}"
                                            aria-label="{{ subitem2.text }}"
                                            (click)="toggleSubmenuClick($event)"
                                            (mouseenter)="toggleSubmenuHover($event)"
                                            >
                                            @if (subitem2.alert) {
                                              <span
                                                class="float-right"
                                                [ngClass]="subitem2.label || 'badge badge-success'"
                                                >{{ subitem2.alert }}</span
                                                >
                                              }
                                              @if (subitem2.icon) {
                                                <em class="{{ subitem2.icon }}"></em>
                                              }
                                              <span>{{ subitem2.text }}</span>
                                            </button>
                                          }
                                          <!-- SUBLEVEL 3 -->
                                          @if (subitem2.submenu) {
                                            <ul
                                              class="sidebar-nav sidebar-subnav level3"
                                              [routerLinkActive]="['opening']"
                                              >
                                              @for (subitem3 of subitem2.submenu; track subitem3) {
                                                <li
                                                  [routerLinkActive]="['active']"
                                                  >
                                                  <!-- sublevel 2: single menu item  -->
                                                  @if (!subitem3.submenu) {
                                                    <a
                                                      [routerLink]="subitem3.link"
                                                      [attr.route]="subitem3.link"
                                                      title="{{ subitem3.text }}"
                                                      >
                                                      @if (subitem3.alert) {
                                                        <span
                                                          class="float-right"
                                                          [ngClass]="subitem3.label || 'badge badge-success'"
                                                          >{{ subitem3.alert }}</span
                                                          >
                                                        }
                                                        @if (subitem3.icon) {
                                                          <em
                                                            class="{{ subitem3.icon }}"
                                                          ></em>
                                                        }
                                                        <span>{{ subitem3.text }}</span>
                                                      </a>
                                                    }
                                                    <!-- sublevel3: has submenu -->
                                                    @if (subitem3.submenu) {
                                                      <button
                                                        type="button"
                                                        class="nav-link"
                                                        title="{{ subitem3.text }}"
                                                        aria-label="{{ subitem3.text }}"
                                                        (click)="toggleSubmenuClick($event)"
                                                        (mouseenter)="toggleSubmenuHover($event)"
                                                        >
                                                        @if (subitem3.alert) {
                                                          <span
                                                            class="float-right"
                                                            [ngClass]="subitem3.label || 'badge badge-success'"
                                                            >{{ subitem3.alert }}</span
                                                            >
                                                          }
                                                          @if (subitem3.icon) {
                                                            <em
                                                              class="{{ subitem3.icon }}"
                                                            ></em>
                                                          }
                                                          <span>{{ subitem3.text }}</span>
                                                        </button>
                                                      }
                                                      <!-- SUBLEVEL 4 -->
                                                      @if (subitem3.submenu) {
                                                        <ul
                                                          class="sidebar-nav sidebar-subnav level3"
                                                          [routerLinkActive]="['opening']"
                                                          >
                                                          @for (subitem4 of subitem3.submenu; track subitem4) {
                                                            <li
                                                              [routerLinkActive]="['active']"
                                                              >
                                                              <!-- sublevel 2: single menu item  -->
                                                              @if (!subitem4.submenu) {
                                                                <a
                                                                  [routerLink]="subitem4.link"
                                                                  [attr.route]="subitem4.link"
                                                                  title="{{ subitem4.text }}"
                                                                  >
                                                                  @if (subitem4.alert) {
                                                                    <span
                                                                      class="float-right"
                                                                      [ngClass]="subitem4.label || 'badge badge-success'"
                                                                      >{{ subitem4.alert }}</span
                                                                      >
                                                                    }
                                                                    @if (subitem4.icon) {
                                                                      <em
                                                                        class="{{ subitem4.icon }}"
                                                                      ></em>
                                                                    }
                                                                    <span>{{ subitem4.text }}</span>
                                                                  </a>
                                                                }
                                                              </li>
                                                            }
                                                          </ul>
                                                        }
                                                      </li>
                                                    }
                                                  </ul>
                                                }
                                              </li>
                                            }
                                            <li></li>
                                          </ul>
                                        }
                                      </li>
                                    }
                                    <li></li>
                                  </ul>
                                }
                              </li>
                            }
                            <!--Mobile view only -->
                            <li class="nav-item d-block d-md-none">
                              @if (issuingEntity && user.issuingEntites.length > 1 && user.isInRole('AgencyUser')) {
                                <button
                                  type="button"
                                  class="nav-link"
                                  title="Agency"
                                  aria-label="Change agency"
                                  (click)="changeIssuingEntity()"
                                  style="cursor: pointer"
                                  >
                                  <em class="bi bi-arrow-left-right" aria-hidden="true"></em>{{ issuingEntity.name }}
                                </button>
                              }
                              @if (user.issuingEntites.length == 1) {
                                <label class="nav-link">
                                  <span class="entity">{{ user.issuingEntites[0].name }}</span>
                                </label>
                              }
                            </li>

                            <li class="nav-item d-block d-md-none">
                              <a class="nav-link" [routerLink]="'/users/profile'">
                                <em class="bi bi-person" aria-hidden="true"></em> Profile
                              </a>
                            </li>
                          </ul>
                          <!-- END sidebar nav-->
                          <div class="version">
                            <span class="">{{ version }}</span>
                          </div>
                        </nav>
                      </div>
                      <!-- END Sidebar (left)-->

                      <ng-template #selectIssuingEntity let-c="close" let-d="dismiss">
                        <div class="modal-header">
                          <h4 class="modal-title" id="modal-basic-title">Select Agency</h4>
                          <button
                            type="button"
                            class="close"
                            aria-label="Close"
                            (click)="d('Cross click')"
                            >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <app-select-issuing-entity
                            (refresh)="onRefresh($event)"
                          ></app-select-issuing-entity>
                        </div>
                      </ng-template>
